<script>
  import { _, locale } from 'svelte-i18n';
  import { isEmptyOrUndefinedString, resolveDatePhrase } from '@app/utils/util';
  import { getConfig } from '@app/config';

  const { modules } = getConfig();

  export let event;
  export let moduleName;

  let weekDayLookup = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
</script>

<div class="event__list__item" lang="{$locale}">
  <!-- Image -->
  <img
    class="event__list__item__img"
    src="{event.images[0] ? event.images[0].url : modules[moduleName].placeholderImage ? modules[moduleName].placeholderImage.url : ''}"
    alt="{!isEmptyOrUndefinedString(event.name[$locale]) ? event.name[$locale] : event.name.fi}"
  />

  <!-- Location -->
  <div class="location__date">
    <span class="location__date__locality" lang="{event.location.address_locality[$locale] ? $locale : 'fi'}">
      {event.location.address_locality[$locale] ? event.location.address_locality[$locale] : event.location.address_locality.fi}</span
    >
    <span class="location__date__dates" lang="{$locale}">{resolveDatePhrase(event.start_time, event.end_time)}</span>
  </div>

  <div class="event__list__item__content__wrapper">
    <!-- Name -->
    <h4 class="event__list__item__name" lang="{event.name[$locale] ? $locale : 'fi'}">{!isEmptyOrUndefinedString(event.name[$locale]) ? event.name[$locale] : event.name.fi}</h4>

    <!-- Weekdays open -->
    {#if event.opening_hours}
    <p class="opening__hours">
      {#each event.opening_hours as weekday}
      <span class="opening__hours__weekday">{$_(`common.weekdays.${weekDayLookup[weekday.day]}`)}</span>
      {/each}
    </p>
    {/if}

    <!-- Location -->
    <span class="location__extra__info" lang="{event.location.name[$locale] ? $locale : 'fi'}">{!isEmptyOrUndefinedString(event.location.name[$locale]) ? event.location.name[$locale] : event.location.name.fi}</span>
  </div>
</div>
